export default {
  /*按钮*/
  bt: {
    search: 'Inquire',
    find: 'Search',
    reset: 'Reset',
    add: 'Add',
    save: 'Save',
    saveAndNext: 'Save to next',
    noAndNext: '暂不评估，下一条',
    operator: 'Operating',
    update: 'Modify',
    delete: 'Delete',
    down: 'Download',
    export: 'Export',
    upload: 'Upload',
    hideOrNo: 'Show/hide list',
    definite: 'Confirm',
    cancel: 'cancel',
    addOne: 'Add 1',
    edit: 'Edit',
    allSelect: 'Select all',
    downModel: 'Download template',
    uploadNow: 'Upload all',
    allOpen: 'Expand all',
    allClose: 'Close all'
  },
  /*公用字段或工具函数字段*/
  common: {
    companyId: 'Company id',
    bizCode: 'Business',
    bizCodeName: 'Business',
    placeholderBizCodeName: 'Please select business',
    locale: 'Language',
    placeholderLanguage: 'Please select language',
    enable: 'status',
    startTime: 'Starting time',
    placeholderStartTime: 'Select started time',
    endTime: 'Finished time',
    placeholderEndTime: 'Select finished time',
    createDate: 'Creation time',
    updateDate: 'Update time',
    replyTime: 'Access time',
    enableNo: 'Disable',
    enableYes: 'Enable',
    no: 'No',
    yes: 'Yes',
    online: 'Online',
    business: 'Busy',
    offline: 'Offline',
    tip: 'Tips',
    mobile: 'Mobile',
    pc: 'PC',
    app: 'APP',
    cancelDel: 'Cancled delected',
    delForever: 'This operation will permanently delete the data, do you continue?',
    delSuc: 'Deleted successfully!',
    delFail: 'Deleted failed, try again later',
    addSuc: 'Added successfully!',
    addFail: 'Added failed, please try again later',
    updateSuc: 'Updated successfully!',
    updateFail: 'Updated failed, try again later',
    notExceed: 'Can not add more than 3 items',
    notNull: ' Input content can not be empty, please re-enter!',
    send: 'Send',
    name: 'Name',
    placeholderName: 'Please enter name',
    phone: 'Phone number',
    email: 'Mailbox',
    placeholderEmail: 'Please enter email',
    tel: 'Fixed',
    telephone: 'Phone',
    placeholderPhone: 'Please enter phone number',
    qq: 'QQ',
    placeholderQQ: 'Please enter QQ number',
    weChat: 'WeChat',
    placeholderWeChat: 'Please enter WeChat',
    zalo: 'Zalo',
    facebook: 'Facebook',
    whatsApp: 'Whatsapp',
    remark: 'Remarks',
    placeholderRemark: 'Please enter note information',
    title: 'Title',
    file: 'Files',
    fileTitle: 'File title',
    fileName: 'File name',
    uploadTime: 'Upload time',
    hreAddress: 'Link',
    pic: 'Image',
    picTitle: 'Picture title',
    visitorsType: 'Visitor type',
    placeholderVisitorsType: 'Please select visitor type',
    businessType: 'Business type',
    placeholderBusinessType: 'Please select business type',
    traveler: 'Visitor',
    demo: 'Demo',
    inactivated: 'Not activated',
    activated: 'Activated',
    accountNum: 'Trading account',
    placeholderAccountNum: 'Please enter trading number',
    visitorsName: 'Visitor name',
    placeholderVisitorsName: 'Please enter visitor name',
    visitorsID: 'Visitor id',
    placeholderVisitorsID: 'Please enter visitor ID',
    visitorsIp: 'Visitor IP',
    placeholderVisitorsIp: 'Please enter the guest IP',
    visitorsAddress: 'Visitor area',
    placeholderProvince: 'Please select province',
    placeholderCity: 'Please select city',
    visitorsSource: 'Visitor source',
    visitorsNum: 'Visits',
    massageTime: 'Message Time',
    status: 'status',
    placeholderStatus: 'Please select visitor status ',
    replayTime: 'Response Time',
    massageType: 'Message type',
    replayOperator: 'Responder',
    placeholderReplayOperator: 'Please enter the respondent',
    detail: 'Details',
    userTypeName: 'Cients status',
    visitorsWay: 'Interview method',
    sort: 'Sort',
    content: 'Content',
    clientDetail: 'Browser',
    address: 'Location',
    lastAccessAddress: 'Recently visited page',
    userID: 'Customer ID',
    sex: 'Sex',
    boy: 'Man',
    girl: 'Woman',
    placeholderSex: 'Please select sex',
    tradePlatform: 'Trading platform',
    accountStatus: 'Account status',
    activeTime: 'Activation time',
    lastMoneyTime: 'Last deposit time',
    tradeHandNum: 'Acumulative traded lots',
    lastTradeTime: 'Last trading time',
    accountChannel: 'Account opening channel',
    activityNum: 'Number of activities involved',
    ccFollow: 'CC follower',
    placeholderCC: 'Please enter CC follower',
    csFollow: 'CS follower',
    placeholderCS: 'Please enter CS follower',
    rmFollow: 'RM follower',
    placeholderRM: 'Please enter RM follower',
    chatTheme: 'Conversation topic',
    placeholderChatTheme: 'Please select a conversation topic',
    chatLevel: 'Session level',
    placeholderChatLevel: 'Please select a conversation level',
    placeholderKeywords: 'Please enter key words',
    userSource: 'Visitor channel',
    serviceName: 'Customer Service Name',
    placeholderServiceName: 'Please select customer service name',
    sessionTime: 'Time Length of conversation',
    userIp: 'Access IP',
    serviceQuality: 'service quality',
    placeholderServiceQuality: 'Please select service quality',
    chatRecordKey: 'Chat history keywords',
    placeholderChatRecordKey: 'Please enter the chat record keyword',
  },
  /**
   * 文件上传
   */
  upload: {
    numPrefix: 'Can only choose',
    numMid: 'files, currently have selected',
    numSuffix: 'files',
    uploadTitle: 'Files upload',
    success: 'Files upload successfully',
    fail: 'Files upload failed',
    pleaseUpload: 'Please upload files',
    excelTipOne: 'Can only upload files with suffix is .xlsm ',
    excelTipTwo: 'File size can not more than 10M',
    uploadTipPrefix: 'Drag the file here, or',
    uploadTipSuffix: 'Click to upload',
    uploadNumTip: 'Can only upload files with suffix is .xlsm and not exceed 10M',
    downExample: 'Download template',
    uploadButton: 'Upload immediately',
    uploadPicTip: 'Only upload jpg/png files and no more than 500kb',
    uploadImgTip: 'Only upload jpg/png/gif files！',
    uploadPicFail: 'Picture upload failed, please try later！',
    uploadingImg: 'Picture uploading'
  },
  /**
   * 机器人配置页面
   */
  robotList: {
    name: 'Name',
    welcome: 'Robot welcome',
    remark: 'Description'
  },
  /**
   * 知识分类页面
   */
  knowledgeCategoryList: {
    name: 'Category Name',
    remark: 'Classification description',
    createDateRange: 'Creation time'
  },
  /**
   * 知识库页面
   */
  knowledgeList: {
    name: 'Knowledge name',
    title: 'Knowledge title',
    keywords: 'Key words',
    keywordsPlaceholder: 'Multiple keywords are separated by commas',
    categoryId: 'knowledge classification',
    recommend: 'Recommend',
    content: 'Answer',
    createDateRange: 'Creation time',
    export: 'Derive knowledge',
    exportName: 'Derive  knowledge base',
    upload: 'Batch Import',
    recommendNo: 'Tot recommend',
    recommendYes: ' Recommend',
    operatorName: 'Founder',
    open: 'Open account',
    deposit: 'Savings',
    withdraw: 'Withdraw',
    transaction: 'Trade',
    activities: 'New activities',
    category: 'Category',
    weight: 'Weight',
    searchNum: 'Search times',
    usefulNum: 'Useful times',
    uselessNum: 'Useless times'
  },
  /**
   * 场景配置
   */
  sceneList: {
    name: 'Scene title',
    namePlaceholder: 'Please enter the scene title',
    welcomeMessage: 'Incoming message',
    directManual: 'Whether direct to labor',
    createDateRange: 'Creation time',
    addTitle: 'Add new scene',
    formBizCode: 'Business',
    formBizCodePlaceholder: 'Select your business',
    recommendKnowledge: 'Recommend knowledge',
    selectKnowledge: 'choose knowledge',
    localePlaceholder: 'Please choose language',
    manualService: 'Manual customer service',
    directManualService: 'Direct manual service',
    knowledgeTitle: 'Knowledge title',
    knowledgeTitlePlaceholder: 'Please enter the knowledge title',
    knowledgeType: 'Knowledge type',
    knowledgeTypePlaceholder: 'Please select the knowledge type',
    startDate: 'Starting time',
    startDatePlaceholder: 'Choose start time',
    endDate: 'End Time',
    endDatePlaceholder: 'Choose end time',
    knowledgeId: 'knowledge ID',
    knowledgeName: 'Knowledge name',
    formKnowledgeTitleValid: 'Please enter the scene title',
    formKnowledgeBizCodeValid: 'Please select your business',
    formKnowledgeLocaleValid: 'Plese choose the language'
  },
  /**
   * 个人欢迎语
   */
  privateWelcome: {
    message: 'Content'
  },
  /**
   * 自动回复设置
   */
  privateAutoAnswer: {
    message: 'Content'
  },
  /**
   * 首页
   * */
  imIndex: {
    chatStatus: 'Please select customer service status',
    chatDisconnect: 'Chat link disconnected, reconnect',
    refresh: 'Reconnect',
    chatTip: 'Customer service tips',
    chatTipCon: 'You have some new information, please check',
    notWebSocket: 'Your brower is not supported socket',
    onopen: 'Make connections ...',
    onclose: 'Disconnect ...',
    onmessage: 'Connection successfully'
  },
  /**
   * 内部协同
   */
  chatAllSystem: {
    inputChatName: 'Please enter customer service nickname',
    cueHim: '@他',
    personToPerson: 'Private chat'
  },
  /**
   * Conversation level
   */
  chatLevel: {
    createLevel: 'New session level',
    updateLevel: 'Modify session level',
    chatLevel: 'Session level',
    level: 'Level'
  },
  /**
   * Dialogue topic
   */
  chatTheme: {
    createTheme: 'New topic',
    updateTheme: 'Modify theme',
    theme: 'theme'
  },
  /**
   * Desktop dialog window settings
   */
  desktopChat: {
    clickEditLogo: 'Click to edit LOGO',
    editLogo: 'Edit LOGO',
    clickEditBgColor: 'Click to edit ad',
    editBgColor: 'Edit background color',
    background: 'Background color',
    clickAd1: 'Click to edit ad one',
    clickAd2: 'Click to edit ad two',
    editAd: 'Edit Ad',
    isVerify: 'Whether to open an account verification code',
    logoHrefUrl: 'Jump link',
    inputLogoHrefUrl: 'Please enter a jump link',
    adPic: 'Advertising picture'
  },
  /**
   * 访客IP限制设置
   */
  limitVisitorsIP: {
    addLimit: 'Add visitor limit',
    updateLimit: 'Modify visitor limit',
    limitType: 'Limit Type',
    limitTypeCon: 'Limit type content',
    placeholderLimitType:"Please enter IP or account",
    limitReason: 'Reason for blocking',
    ip: 'IP',
    account: 'account'
  },
  /**
   * 留言设置
   */
  message: {
    title: 'Customer service offline customer information message collection',
    titleCon: 'Customer service offline message refers to the current customer service is offline when the customer is online, and the customer leaves a message. ',
    form: 'Form item',
    isRequired: 'Is it required',
    adaptationBizCode: 'Adaptation business',
    EffectPreview: 'Effect Preview',
    message: 'Message',
    editMessageGuide: 'Edit Message Guide',
    clickEditMessageGuide: 'Edit Message Guide',
    messageGuide: 'Message guide',
    messageSuc: 'Message success page content'
  },
  /**
   * 常用文件管理/链接管理/图片管理
   */
  oftenFile: {
    inputTitleKey: 'Please enter the title keyword',
    uploadFile: 'Upload file',
    updateFile: 'Modify file',
    addOftenHref: 'New frequently used link',
    updateOftenHref: 'Modify common links',
    hrefUrl: 'Link address',
    titleOrHref: 'Title or link address cannot be empty',
    pic: 'Picture',
    uploadPic: 'upload image'
  },
  /**
   * 访问分配设置
   */
  visitorsDistribution: {
    prioritySet: 'Priority setting',
    priorityCon: 'Priority will be allocated to the last customer service within <em>(Note: the default is 5 minutes)</em>',
    priorityExplain: 'If the visitor is not online for the first time, the visitor will be assigned to the last assigned customer service within the specified time. If the last customer service is not online, it will be assigned as an ordinary customer;',
    allocationSet: 'Allocation method setting',
    allocationType1: 'Sales type-the system will allocate visitors to each customer service staff in turn. If the current customer service limit is full, skip it.',
    allocationType0: 'Customer service type-the system assigns to the customer service with a small workload (the workload is equal to the number of visitors currently received divided by the number of online receptions), if the load is the same, it is assigned to the customer service who has not received new visitors for the longest time',
    allocationType2: 'Prioritize the customer service with the fewest conversations',
    editChatRelated: 'Customer Service Association Edit',
    chatId: 'Customer Service ID',
    id: 'ID',
    userName: 'Log-in name',
    displayName: 'nickname',
    rolesStr: 'Character',
    companyName: 'Company',
    relatedBusiness: 'related business',
    upperLimit: 'Reception upper limit',
    minute: 'minute',
    second: 'second',
    hour: 'Hour'
  },
  /**
   * 欢迎语
   */
  welcome: {
    title: 'Welcome',
    addWelcome: 'Add welcome message',
    updateWelcome: 'Add welcome message'
  },
  /**
   * 留言管理
   */
  messageManagement: {
    messageDetailTitle: 'Message Details',
    messageCon: 'Message content',
    replyCon: 'Reply content',
    placeholderReply:"Please enter the reply content",
    replyNo: 'Unanswered',
    replyYes: 'Replied',
    all: 'All',
    cityArea: 'City area',
    saveMessageSuc: 'Save the message successfully',
    saveMessageFail: 'Failed to save the message, please try again later! ',
    isNull: 'Reply content cannot be empty! ',
    messageExport: 'Message export'
  },
  /**
   * 聊天框
   */
  chatRoom: {
    offline: 'Customer is offline',
    artificialChat: 'Receive this user',
    artificialFail: 'Reception failed, please try again! ',
    notArtificial: 'There is currently no chat partner and cannot receive users, please select chat partner first! ',
    fileType: 'The file format is wrong',
    picType: 'Picture cannot exceed 5M',
    sendNotNull: 'Send content cannot be empty',
    notSend: 'There is currently no chat partner, so you cannot send a message, please select a chat partner first! ',
    noMore: 'No more data'
  },
  /**
   * 对话管理
   */
  commonChat: {
    waitAccept: 'To be connected',
    waitEvaluated: 'To be evaluated',
    acceptSession: 'Accept the conversation',
    limitVisitorsIP: 'Guest IP restriction settings',
    chatMonitor: 'Monitor customer service',
    enableAutoReply:"Start automatic reply",
    closeAutoReply:"Turn off automatic replies",
    customerInfo: 'Customer Information',
    historyChat: 'Historical conversation',
    sourceHref: 'Click to view source link',
    chatList: 'Conversation list',
    chatEnd: 'End the conversation',
    chatSend: 'Send conversation',
    waitAcceptInfo: 'Pending access information',
    accept: 'Access',
    acceptAll: 'All access',
    send: 'Send',
    waitEvaluatedInfo: 'Information to be evaluated',
    goEvaluated1: 'and',
    goEvaluated2: 'Evaluate',
    chatRecord1: 'and',
    chatRecord2: 'Dialog record',
    chatStart: 'Dialog start',
    chatEnds: 'Dialog end',
    customerOff: 'Customer is offline',
    chatClose: 'Customer service takes the initiative to close the session',
    evaluatedInfo: 'Evaluation Information',
    isNotNull: 'The conversation subject and conversation level cannot be empty! ',
    acceptSessionInfo: 'Accept dialog information',
    reception: 'Accept',
    refusal: 'Refusal',
    chatSendInfo: 'Send dialog information',
    sender: 'Sender',
    receiver: 'Receiver',
    chatID: 'Session id',
    sendReason: 'Reason for transmission',
    placeholderSendReason: 'Please enter the reason for sending',
    chatInfo: 'Session Details',
    checkChatMonitor: 'Choose to monitor customer service',
    noData: 'No data',
    commonWords: 'Common Common Words',
    personalWords: 'Personal Common Words',
    commonHref: 'Common Links',
    commonImg: 'Common Pictures',
    commonFile: 'Common File',
    endReason: 'End Reason',
    checkChat: 'Please select a conversation client!',
    notEdit: 'The current customer information is not editable, please change it to editable first!',
    updateSuc: 'Modify customer information successfully!',
    updateFail: 'Failed to modify customer information, please try again later',
    notCopy: 'This browser does not support automatic copying',
    length: 'The number of search keywords must be greater than or equal to 2!',
    evaluatedSuc: 'Evaluation successful!',
    acceptSuc: 'Access is successful!',
    acceptFail: 'Access failed, please try again later',
    sendSingle: 'Can only send a single session',
    hasSend: 'This conversation has been sent, please send another conversation',
    checkSend: 'Please select the session to be sent first',
    notSender: 'No sender is selected, please select the sender first!',
    sendSuc: 'Successful transmission!',
    sendFail: 'Send failed, please try again later',
    isAccept: 'Do you accept the session?',
    receptionSuc: 'Successful acceptance!',
    receptionFail: 'Acceptance failed, please try again later',
    receptionCancel: 'Reception session has been cancelled',
    isRefusal: 'Do you want to reject the session?',
    refusalSuc: 'Refused to succeed',
    refusalFail: 'Refusal failed, please try again later',
    refusalCancel: 'Refusal session has been cancelled',
    chatEndsFail: 'Failed to end the conversation, please try again later',
    checkChatEnds: 'Please check the session that needs to be ended first',
    startMonitor: 'Start Monitoring',
    monitorFail1: 'Monitor',
    monitorFail2: 'Failed, please try again later'
  },
  /**
   * 对话记录
   */
  chatRecord: {
    visitorsAccount: 'Visitor Account',
    placeholderAccount: 'Please enter account',
    visitorsType: 'Visitor method',
    placeholderVisitorsType: 'Please select visitor method',
    serviceQuality0: 'No comments',
    serviceQuality1: 'One Star',
    serviceQuality2: 'Two Stars',
    serviceQuality3: 'Three Stars',
    serviceQuality4: 'Four Stars',
    serviceQuality5: 'Five Stars',
    saveSuc:"Evaluation successful! This dialogue is the last one on this page. Please go to the list first and turn to the next page",
    noNext: 'This dialogue is the last one on this page. Please go to the list first and turn to the next page'
  },
  /**
   * 常用语
   */
  commonWords: {
    addCommonWordsList: 'Create a new list of common words',
    addCommonWords: 'New common words',
    importAll: 'Batch List of common words',
    commonWordsList: 'common word list',
    placeholderCommonWordsList: 'Please select a list of common words',
    contentTxt: 'Content',
    updateCommonWords: 'Modify common words',
    updateCommonWordsList: 'Modify the list of common words',
    checkDel: 'Please select the option to delete first',
    notCommonWordsList: 'The list of common words cannot be empty, please enter the list of common words',
    notCommonWordsList1: 'The list of common words cannot be empty, please create a list of common words first',
    notTitle: 'Title cannot be empty, please enter a title'
  }
}

